var map = {
	"./1.svg": 53146,
	"./2.svg": 15442,
	"./3.svg": 68617,
	"./add.svg": 96019,
	"./alipay.svg": 32320,
	"./applet.svg": 50371,
	"./article-create.svg": 75249,
	"./article-ranking.svg": 53150,
	"./article.svg": 14286,
	"./auto-scale.svg": 73431,
	"./back.svg": 51133,
	"./base-data.svg": 71042,
	"./bell.svg": 13769,
	"./bind-phone.svg": 69051,
	"./branch-boke.svg": 5171,
	"./branch-frabric.svg": 12571,
	"./branch-maker.svg": 63112,
	"./branch-shop.svg": 2255,
	"./c1.svg": 4087,
	"./c2.svg": 83590,
	"./c3.svg": 2217,
	"./c4.svg": 64849,
	"./camera.svg": 50155,
	"./camera1.svg": 20584,
	"./cart-down.svg": 29932,
	"./change-theme.svg": 22232,
	"./chart.svg": 47999,
	"./client-skin.svg": 38116,
	"./close.svg": 75114,
	"./cloth.svg": 42506,
	"./code.svg": 59839,
	"./contactus.svg": 28023,
	"./customerservices.svg": 71150,
	"./dashboard.svg": 99878,
	"./data-upload.svg": 94943,
	"./deamon.svg": 80551,
	"./delete.svg": 53714,
	"./diagnosis.svg": 73,
	"./down.svg": 4113,
	"./download (2).svg": 90857,
	"./download.svg": 83369,
	"./edit.svg": 62216,
	"./empty.svg": 17273,
	"./error.svg": 68066,
	"./example.svg": 39055,
	"./exit-fullscreen.svg": 1164,
	"./eye-open.svg": 55775,
	"./eye.svg": 73825,
	"./fullscreen.svg": 29076,
	"./gouxuan.svg": 33869,
	"./gouxuan1.svg": 39262,
	"./guide.svg": 70916,
	"./hamburger-closed.svg": 85028,
	"./hamburger-opened.svg": 20813,
	"./heart.svg": 46438,
	"./histoires.svg": 82237,
	"./home.svg": 9265,
	"./home1.svg": 54973,
	"./info.svg": 34224,
	"./international.svg": 68296,
	"./introduce.svg": 6109,
	"./language.svg": 21819,
	"./link.svg": 71267,
	"./loading.svg": 23916,
	"./loading1.svg": 50625,
	"./medtruansfer.svg": 3165,
	"./moneyaccount.svg": 16272,
	"./myreg.svg": 30457,
	"./nested.svg": 93352,
	"./new.svg": 45981,
	"./next.svg": 80929,
	"./outlinepay.svg": 31017,
	"./package.svg": 77527,
	"./password.svg": 20623,
	"./permission.svg": 84620,
	"./person.svg": 49233,
	"./personnel-info.svg": 94035,
	"./personnel-manage.svg": 16634,
	"./personnel.svg": 13666,
	"./play.svg": 94962,
	"./pointleft.svg": 20325,
	"./prev.svg": 88536,
	"./qq.svg": 74426,
	"./refresh.svg": 70886,
	"./reply.svg": 55572,
	"./require.svg": 37640,
	"./reward.svg": 35992,
	"./role.svg": 14495,
	"./scales.svg": 34309,
	"./scales1.svg": 4593,
	"./search.svg": 27372,
	"./search1.svg": 72935,
	"./setting.svg": 47714,
	"./setting1.svg": 90313,
	"./shared.svg": 90962,
	"./shift.svg": 55394,
	"./shop.svg": 53421,
	"./size.svg": 24073,
	"./star.svg": 4108,
	"./success.svg": 30485,
	"./table.svg": 4798,
	"./tel.svg": 21001,
	"./tree.svg": 21555,
	"./up.svg": 24075,
	"./upload.svg": 23852,
	"./user.svg": 23989,
	"./video.svg": 49240,
	"./warn.svg": 34483,
	"./wechat.svg": 58588,
	"./wx.svg": 44605
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42007;